const config = {
  apiUrl: "http://192.168.254.40/TourPort",
  debug: true,
};
export default config;